import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnalyticsModule } from '@hdms/shared/util-core';

import { FormButtonComponent } from './form-button.component';

@NgModule({
  declarations: [FormButtonComponent],
  imports: [CommonModule, AnalyticsModule],
  exports: [FormButtonComponent]
})
export class FormButtonModule {}

export * from './form-button.component';
